<template>
    <Window :id="'addChildSys'" :title="title" :size="'m'" ref="Window">
        <div class="mb05x_E">
            <div class="fs12x" :title="getLanguageStr('word1719','子系统名称')">{{getLanguageStr('word1719','子系统名称')}}</div>
            <InputText class="mb2x" :placeholder="$t('phrase870',['请输入电站名称'])" :verification="'notEmpty'" :clearBtn="true" ref="searchBox" v-model="childText" name="childText"></InputText>
            <div class="fs12x" :title="getLanguageStr('word1720','子系统类型')">{{getLanguageStr('word1720','子系统类型')}}</div>
            <div class="curP_E">
                <label class="mr1x"><input type="radio" name="choose" value="GENERATION" v-model="ChildType">&nbsp;{{getLanguageStr('word559','发电')}}</label>
                <label><input type="radio" name="choose" value="CONSUMPTION" v-model="ChildType">&nbsp;{{getLanguageStr('word561','用电')}}</label>
            </div>
        </div>
        <button slot="btmBtn" class="functionBtn hover-cF bgMain tra-fast" type="button" @click="confirm">{{$t('cmd84',['保存'])}}</button>
    </Window>
</template>
<script>
import Window from "@/components/common/ui/WindowForAlert.vue"
import InputText from "@/components/common/ui/InputText.vue"
import ChildSysConfig from '@/components/common/ChildSysConfig'
import {getLanguageStr} from "@/util/language"
import {AddChildSys,EditChildSys} from '@/api/maintain/plant/list'
export default {
    name:'addChildSys',
    components:{Window,ChildSysConfig,InputText},
    data(){
        return{
            myMode:'new',
            title:'',
            stationId:'',
            childId:null,
            childText:'',
            ChildType:'',
        }
    },
    methods:{
        getLanguageStr,
        show(data){
            this.$refs.searchBox.reset()
            if(this.myMode=='new'){
                this.stationId=data.id
                this.childText=''
                this.ChildType='GENERATION'
                this.title=getLanguageStr('plant_detail114','添加子系统')
            }else{
                this.stationId=data.node.parentId
                this.childId=data.node.id
                this.childText=data.node.name
                this.ChildType=data.node.functionType
                this.title=getLanguageStr('plant161','编辑子系统')
            }
            this.$nextTick(()=>{
                this.$refs.Window.show({
                    title:this.title
                });
            })
            
        },
        modeChange(mode){
            this.myMode=mode
        },
        hide(){
            this.$refs.Window.hide();
        },
        confirm(){
            if(!this.childText){
                this.$refs.searchBox.doVerification()
                return false
            }
            let req={
                name:this.childText,
                functionType:this.ChildType,
            }
            if(this.myMode=='new'){
            	AddChildSys(this.stationId,req).then(res=>{
            		// req.childId = res;
	                this.hide()
	                this.$emit('update',res)
	            },error=>{
	                !_.isEmpty(error) && this.$notify(error)
	            })
            } else {
            	EditChildSys(this.childId,req).then(res=>{
	                this.hide()
	                this.$emit('refreshChildSys')
	            },error=>{
	                !_.isEmpty(error) && this.$notify(error)
	            })
            }
            
        }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/ChildSysConfig.vue